import PropTypes from "prop-types";
import React from "react";

import {DataMode} from "../const";


export const Toggle = (props) => {
  const {
    activeDataMode,
    onChange,
  } = props;

  const getToggleTitle = (mode) => {
    switch (mode) {
      case DataMode.FISH:
        return `«Промысловые рыбы»`;
      case DataMode.NON_FISH:
        return `«Нерыбные объекты промысла»`;
      default:
        return ``;
    }
  };

  return (
    <form className="sidebar__toggle  toggle">
      {
        Object.keys(DataMode).map((mode, index) => {
          return (
            <React.Fragment key={mode + index}>
              <input
                className="visually-hidden"
                id={DataMode[mode]}
                type="radio"
                name="dataMode"
                value={DataMode[mode]}
                checked={DataMode[mode] === activeDataMode}
                onChange={onChange}
              />

              <label className={`toggle__item  ${DataMode[mode] === activeDataMode && `toggle__item--active`}`} htmlFor={DataMode[mode]}>
                {getToggleTitle(DataMode[mode])}
              </label>
            </React.Fragment>
          );
        })
      }
    </form>
  );
};


Toggle.propTypes = {
  activeDataMode: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
